import { TabsMenu } from "components/CustomTabs";
import { ACTIVITY_TABS } from "features/Agent/constants";
import { useSellerPermissions } from "hooks/seller";
import { useSupplierPermissions } from "hooks/supplier";
import { t } from "i18next";
import ActivityLogs from "../ActivityLogs";
import AddressBook from "../AddressBook";
import BuyHistory from "../BuyHistory";
import ListContractTab from "../ListContract";

const ActivityTabs = ({ isSupplier, supplierDetail, activeKey, onChange }) => {
  const { canSupplierContactView } = useSupplierPermissions();
  const { canViewContact } = useSellerPermissions();

  const tabs = [
    {
      title: <span className="title"> {t("seller.activitylogtabs.tabs.activeHistory")}</span>,
      key: ACTIVITY_TABS.ACTIVE_HISTORY,
      children: <ActivityLogs isSupplier={isSupplier} />,
    },
    ...(supplierDetail?.isSeller
      ? [
        {
          title: <span className="title"> {t("seller.activitylogtabs.tabs.buyHistory")}</span>,
          key: ACTIVITY_TABS.BUY_HISTORY,
          children: <BuyHistory />,
        },
      ]
      : []),
    ...((isSupplier ? canSupplierContactView : canViewContact)
      ? [
        {
          title: <span className="title"> {t("seller.activitylogtabs.tabs.bookAddress")}</span>,
          key: ACTIVITY_TABS.BOOK_ADDRESS,
          children: <AddressBook isSupplier={isSupplier} />,
        },
      ]
      : []),
    {
      title: <span className="title"> Danh sách hợp đồng</span>,
      key: ACTIVITY_TABS.CONTRACT,
      children: <ListContractTab isSupplier={isSupplier} sellerID={supplierDetail?.id} />,
    },
  ];

  return (
    <div id="activity-tabs" className="wrapper-tabs">
      <TabsMenu tabs={tabs} activeKey={activeKey} onChange={onChange} />
    </div>
  );
};

export default ActivityTabs;
